import parse from 'html-react-parser'
import styled from 'styled-components'
import { eventManager } from 'event-manager'
import { useRecoilValue } from 'recoil'

import { Box, IconName, ListItem, Text, themeColor } from '@cutover/react-ui'
import { incidentTimezone } from 'main/recoil/apps/apps-atoms'
import { ActivityConfig, ActivityVM } from 'main/services/queries/use-activities'
import { formatActivityDetailsValue, useActivityProperties } from './activity-helper'
import { ActivityInsights } from './activity'

type ActivityHeaderProps = {
  activity: ActivityVM
  activityConfig: ActivityConfig[]
  previousActivity: ActivityVM
  index: number
  active: boolean
  setActive: (index: number | null) => void
  time: string
}

type SubjectProps = {
  text: string
  internalIds?: number[]
}

export const ActivityHeader = ({ activity, activityConfig, time, index, active, setActive }: ActivityHeaderProps) => {
  const { activityIcon, subject, action, activistName } = useActivityProperties(activity, activityConfig)
  const timezone = useRecoilValue<string>(incidentTimezone)
  const handleSetFilters = (internalIds?: number[]) => {
    if (active) {
      eventManager.emit('filter-task-list-by-internal-ids', { internalIds: [] })
      setActive(null)
    } else {
      eventManager.emit('filter-task-list-by-internal-ids', { internalIds })
      setActive(index)
    }
  }

  return (
    <Box align="center" data-testid="activity-info">
      <ListItem
        size={'medium'}
        startComponent={<ActivityInsights time={time} icon={activityIcon as IconName} featured={activity.featured} />}
      >
        <Text weight="bold">{activistName} </Text>
        {activity.display?.inline_message
          ? parse(formatActivityDetailsValue(activity.display?.inline_message, timezone, true))
          : renderSubject(subject, action, handleSetFilters, active)}
      </ListItem>
    </Box>
  )
}

const renderSubject = (
  subject: SubjectProps,
  action: string | undefined,
  handleSetFilters: Function,
  active: boolean
) => {
  if (subject.internalIds) {
    return (
      <>
        {action}{' '}
        <StyledText active={!!active} onClick={() => handleSetFilters(subject.internalIds)}>
          {subject.text}
        </StyledText>
      </>
    )
  } else {
    return (
      <>
        {action} <Text weight="bold">{subject.text}</Text>
      </>
    )
  }
}

const StyledText = styled(Text)<{ active: boolean }>`
  color: ${themeColor('primary')};
  font-weight: ${({ active }) => (active ? 600 : 400)};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`
